export default __webpack_public_path__ + "static/media/cyril.a129a997.png";